// extracted by mini-css-extract-plugin
export default {"FormWrapper":"ReAuthModal_FormWrapper__qVqLs"};